export const ScopeTab = ({ scopeName }: { scopeName: string }) => {
  return (
    <p className="m-0 rounded-b-lg bg-neutral-200 px-3 py-1.5 text-sm font-semibold text-neutral-600">
      {scopeName}
    </p>
  )
}
